<div class="flex flex-col gap-2">
  @if (label()) {
    <label [for]="inputId()">{{ label() | translateKey }}</label>
  }

  <textarea
    pTextarea
    [id]="inputId()"
    [placeholder]="placeholderValue()"
    [value]="value()"
    [disabled]="disabled()"
    [readOnly]="readOnly()"
    [rows]="rows()"
    (input)="onInputText($event)"
    (blur)="onBlur()"
    class="p-textarea p-component"
    [ngClass]="{
      'ng-invalid ng-dirty': hasErrorSignal(),
      'w-full': fullWidth(),
      'h-full': fullHeight(),
    }"
  ></textarea>

  @if (hasErrorSignal()) {
    <app-form-field-error [controlName]="ngControl"></app-form-field-error>
  }
</div>
